import { render, staticRenderFns } from "./results_table.vue?vue&type=template&id=6cf87a2a&"
import script from "./results_table.vue?vue&type=script&lang=js&"
export * from "./results_table.vue?vue&type=script&lang=js&"
import style0 from "./results_table.vue?vue&type=style&index=0&id=6cf87a2a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports